module.exports = __webpack_public_path__ + "static/media/az.084f1ca8.svg";